module.exports = __webpack_public_path__ + "img/shouch_wenzi.946b813b.png";